const DB_NAME = 'map-canvas-cache';
const STORE_NAME = 'canvases';

function isIndexedDbAvailable() {
  return typeof indexedDB !== 'undefined';
}

function openDb() {
  if (!isIndexedDbAvailable()) {
    return Promise.resolve(null);
  }

  return new Promise((resolve, reject) => {
    const request = indexedDB.open(DB_NAME, 1);

    request.onupgradeneeded = event => {
      const db = event.target.result;
      if (!db.objectStoreNames.contains(STORE_NAME)) {
        db.createObjectStore(STORE_NAME);
      }
    };

    request.onsuccess = event => {
      resolve(event.target.result);
    };

    request.onerror = () => {
      reject(request.error);
    };
  });
}

function requestToPromise(request) {
  return new Promise((resolve, reject) => {
    request.onsuccess = () => resolve(request.result);
    request.onerror = () => reject(request.error);
  });
}

function canvasToBlob(canvas) {
  if (canvas.toBlob) {
    return new Promise(resolve => {
      canvas.toBlob(blob => resolve(blob), 'image/png');
    });
  }

  const dataUrl = canvas.toDataURL('image/png');
  const byteString = atob(dataUrl.split(',')[1]);
  const arrayBuffer = new ArrayBuffer(byteString.length);
  const intArray = new Uint8Array(arrayBuffer);
  for (let i = 0; i < byteString.length; i += 1) {
    intArray[i] = byteString.charCodeAt(i);
  }
  return Promise.resolve(new Blob([intArray], { type: 'image/png' }));
}

async function blobToCanvas(blob, width, height) {
  const canvas = document.createElement('canvas');
  canvas.width = width;
  canvas.height = height;
  const ctx = canvas.getContext('2d');

  if (typeof createImageBitmap === 'function') {
    const bitmap = await createImageBitmap(blob);
    ctx.drawImage(bitmap, 0, 0);
    return canvas;
  }

  const imageUrl = URL.createObjectURL(blob);
  const image = new Image();

  const loaded = new Promise((resolve, reject) => {
    image.onload = resolve;
    image.onerror = reject;
  });

  image.src = imageUrl;
  await loaded;
  ctx.drawImage(image, 0, 0);
  URL.revokeObjectURL(imageUrl);

  return canvas;
}

export async function getCachedCanvas(key, width, height) {
  try {
    const db = await openDb();
    if (!db) {
      return null;
    }
    const transaction = db.transaction(STORE_NAME, 'readonly');
    const store = transaction.objectStore(STORE_NAME);
    const blob = await requestToPromise(store.get(key));
    if (!blob) {
      return null;
    }
    return await blobToCanvas(blob, width, height);
  } catch {
    return null;
  }
}

export async function setCachedCanvas(key, canvas) {
  try {
    const db = await openDb();
    if (!db) {
      return;
    }
    const blob = await canvasToBlob(canvas);
    const transaction = db.transaction(STORE_NAME, 'readwrite');
    const store = transaction.objectStore(STORE_NAME);
    store.put(blob, key);
  } catch {
    // Best-effort cache; ignore failures.
  }
}
